package com.iregained.site.components.sections.patients.styles

import com.iregained.site.theme.toSitePalette
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.selectors.hover
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.s

// ==========================================
// EXPERIENCE SECTION STYLES
// ==========================================

val ExperienceImageStyle = CssStyle {
    base {
        val palette = colorMode.toSitePalette()
        Modifier
            .boxShadow(0.px, 20.px, 40.px, color = palette.custom.darkText.toRgb().copyf(alpha = 0.08f))
            .transition(
                Transition.of("transform", 0.5.s),
                Transition.of("box-shadow", 0.5.s)
            )
    }
    hover {
        val palette = colorMode.toSitePalette()
        Modifier
            .scale(1.02)
            .boxShadow(0.px, 30.px, 50.px, color = palette.brand.primary.toRgb().copyf(alpha = 0.15f))
    }
}

val ExperienceFeatureItemStyle = CssStyle {
    base {
        Modifier.transition(Transition.of("transform", 0.3.s))
    }
    hover {
        // A very subtle shift to the right when hovering over a feature to make it feel interactive
        Modifier.translateX(5.px)
    }
}

val ExperienceIconContainerStyle = CssStyle {
    base {
        val palette = colorMode.toSitePalette()
        Modifier
            .backgroundColor(palette.brand.primarySoft)
            .color(palette.brand.primary)
            .transition(
                Transition.of("background-color", 0.3.s),
                Transition.of("color", 0.3.s)
            )
    }
    // When the parent FeatureItem is hovered, invert the icon colors
    cssRule("*:hover > &") {
        val palette = colorMode.toSitePalette()
        Modifier
            .backgroundColor(palette.brand.primary)
            .color(palette.custom.lightGray)
    }
}